import mixpanel from 'mixpanel-browser';

/* Types */
import { AnalyticsOptions } from './AnalyticsOptions';
import { AnalyticsHandler } from './IAnalyticsHandler';

export const MIXPANEL_KEY =
  process.env.REACT_APP_ENV === 'dev'
    ? 'acc8c88a25df79b585ed93dc5ef2b51c'
    : 'ca0217b697a8ef3e8b5855e1121b88c4';

export class MixpanelOptions extends AnalyticsOptions {}

export class MixpanelAnalyticsHandler extends AnalyticsHandler {
  private analytics: any;

  constructor() {
    super();

    this.initialize();
  }

  protected initialize(): void {
    mixpanel.init(MIXPANEL_KEY, {
      debug: process.env.REACT_APP_ENV === 'dev',
      track_pageview: true,
      persistence: 'localStorage',
    });

    this.analytics = mixpanel;
  }

  public log(logEventTag: string, options: any[]): void {
    const mixpanelOptions = new MixpanelOptions(options);
    this.analytics.track(logEventTag, mixpanelOptions.values[0]);
  }

  public reset(): void {
    this.analytics.reset();
  }
}
